import { getAccessToken } from '@/shared/services/accessToken';
import { sharedTypes } from './constants';

import type { Action, SharedState } from '../types';

const initialState: SharedState = {
	audioOn: true,
	accessToken: getAccessToken() ?? null,
};

export default function sharedReducer(state = initialState, action: Action): SharedState {
	const { type, payload } = action;

	const { audioOn, data } = payload || {};

	switch (type) {
		case sharedTypes.LOGIN_REQUEST:
			return state;

		case sharedTypes.LOGIN_SUCCESS:
			return {
				...state,
				accessToken: data?.accessToken ?? null,
			};

		case sharedTypes.LOGIN_ERROR:
			return state;

		case sharedTypes.SEND_EVENT_SUCCESS:
			return {
				...state,
				...data,
			};

		case sharedTypes.SEND_EVENT_ERROR:
			return {
				...state,
			};

		case sharedTypes.SET_AUDIO_ON:
			return {
				...state,
				audioOn,
			};

		default:
			return state;
	}
}
